export const telemonitoringSearchParams = `
    [
        {
            "active": true,
            "canSave": false,
            "property": {
                "name": "surname",
                "value": "",
                "type": "string"
            },
            "labelTranslationKey": "LastName",
            "layout": {
                "row": 0,
                "column": 0,
                "autofocus": true,
                "stretch": true
            }
        },
        {
            "active": true,
            "canSave": false,
            "property": {
                "name": "name",
                "value": "",
                "type": "string"
            },
            "labelTranslationKey": "FirstName",
            "layout": {
                "row": 0,
                "column": 1,
                "stretch": true
            }
        },
        {
            "active": false,
            "canSave": false,
            "property": {
                "name": "patientId",
                "value": "",
                "type": "string"
            },
            "labelTranslationKey": "PatientId",
            "layout": {
                "row": 1,
                "column": 0,
                "stretch": true
            }
        },
        {
            "active": true,
            "canSave": false,
            "property": {
                "name": "idExams",
                "value": null,
                "type": "multiSelect",
                "itemsSourceInfo": {
                    "form": "visit",
                    "controllerName": "List",
                    "methodName": "GetMonitoringExams",
                    "enableTooltip": true
                }
            },
            "labelTranslationKey": "TelemonitoringType",
            "layout": {
                "row": 2,
                "column": 0,
                "stretch": true
            }
        },
        {
            "active": true,
            "canSave": true,
            "property": {
                "name": "date",
                "value": {
                    "from": "0#-2#0",
                    "to": "0#0#0"
                },
                "defaultValue": {
                    "from": "0#-2#0",
                    "to": "0#0#0"
                },
                "type": "fromTo"
            },
            "labelTranslationKey": {
                "from": "From",
                "to": "To",
                "label": "EnrolmentStartDate"
            },
            "layout": {
                "row": 3,
                "column": 0,
                "stretch": true
            }
        },
       {
            "active": true,
            "canSave": false,
            "property": {
                "name": "approvalDate",
                "value": {
                    "from": "",
                    "to": ""
                },
                "defaultValue": {
                    "from": "",
                    "to": ""
                },
                "type": "fromTo"
            },
            "labelTranslationKey": {
                "from": "From",
                "to": "To",
                "label": "EnrolmentEndDate"
            },
            "layout": {
                "row": 4,
                "column": 0,
                "stretch": true
            }
        },
        {
            "active": true,
            "canSave": false,
            "property": {
                "name": "idReferringPhysician",
                "value": null,
                "type": "filterSelect",
                "itemsSourceInfo": {
                    "form": "visit",
                    "controllerName": "List",
                    "methodName": "GetReferringPhysicians",
                    "displayProperty": "description",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    }
                }
            },
            "labelTranslationKey": "ReferringPhysician",
            "layout": {
                "row": 5,
                "column": 0,
                "stretch": true
            }
        }
    ]`;
